import { OrganizationDropDownModel } from '../../organization/models/organization.model';

export class SearchBookingModel {
  public startDateTime: string;
  public endDateTime: string;
  public isRecurring: boolean = false;
  public recurringPeriod: string = 'DAILY';
  public recurringEndDateTime: string;
  public reccuringID: string;
  public vehicleHashId: string;
  public sharedVehicleGroupHashID: string;
  public bookingMasterHashId: string;
  public driverHashId: string;
  public driverName: string;
  public isEditMode: boolean = false;
  public editBookingMasterHashId: string;
  public isSpecialPeriod: boolean = false;
  public bookingRemarks: string;
  public vehicleLicenceTag: string;
  public isRecurringBookingAllow: boolean = false;
  public totalBookingDuration: string;
  public pickupAddress: string;
  public pickupLat: number;
  public pickupLong: number;
  public organizationIdHashID: string = '';
  public organizationList: OrganizationDropDownModel[] = [];
  public dateOfBirth: string;
  public isFromMobileSide: boolean;
  public organizationName: string;
  // public dayStartDate: string;
  // public dayEndDate: string;
  // public weekendContainingDate: string;
  public specialPeriodType: string = 'regular';
  public specialPeriodName: string;
  public isRegularbooking: boolean = true;
  public contractTypeHashId: string;
  public specialPeriodContractTypeName: string;
  public freeTextSpecialPeriod: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/search-booking.model.ts